module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('general-item', {
    attrs: {
      "format": "popup"
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.in_a_popup')))]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.one_box_apper_in_the_middle')))])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-a5b0df54!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/types/items/Popup.vue
 ** module id = 896
 ** module chunks = 1
 **/